export { default } from './AbstractSubmissionPage';
